import React from 'react'

const icon = (paths) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
        {paths}
    </svg>
)

/** Shared with the navbar profile menu's "Dashboard" row. */
export const DASHBOARD_ICON = icon(
    <>
        <rect x="3" y="3" width="7" height="9" rx="1.5" />
        <rect x="14" y="3" width="7" height="5" rx="1.5" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" />
        <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </>,
)

/**
 * Admin sidebar links — same destinations as the former profile-dropdown admin block.
 * All of them render inside the /admin shell (layout route in App.js).
 */
/** Ungrouped links (Dashboard + the three most-used tools) come first; a link's `group` is the heading key (NAVBAR ns). */
export const ADMIN_SIDEBAR_GROUPS = ['Other']

export const ADMIN_SIDEBAR_LINKS = [
    {
        to: '/admin',
        end: true,
        labelKey: 'Dashboard',
        icon: DASHBOARD_ICON,
    },
    {
        to: '/admin/organisations',
        labelKey: 'Organizer',
        icon: icon(
            <>
                <path d="M3 21V7l9-4 9 4v14" />
                <path d="M9 21V11h6v10" />
            </>,
        ),
    },
    {
        to: '/admin/reservation-history',
        labelKey: 'Reservation history',
        icon: icon(
            <>
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M8 2v4M16 2v4M4 10h16" />
            </>,
        ),
    },
    {
        to: '/admin/invoices',
        labelKey: 'Invoices',
        icon: icon(
            <>
                <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
                <path d="M14 3v5h5M9 13h6M9 17h6" />
            </>,
        ),
    },
    {
        to: '/admin/users',
        labelKey: 'Users',
        group: 'Other',
        icon: icon(
            <>
                <circle cx="9" cy="8" r="3.5" />
                <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
                <circle cx="17" cy="9" r="2.5" />
                <path d="M16 19a4 4 0 0 1 5 0" />
            </>,
        ),
    },
    {
        to: '/admin/banned-list',
        labelKey: 'Banned list',
        group: 'Other',
        icon: icon(
            <>
                <circle cx="12" cy="12" r="9" />
                <path d="m7 7 10 10" />
            </>,
        ),
    },
    {
        to: '/admin/import-registrations',
        labelKey: 'Import registrations',
        group: 'Other',
        icon: icon(
            <>
                <path d="M12 3v12" />
                <path d="m7 10 5 5 5-5" />
                <path d="M4 19h16" />
            </>,
        ),
    },
    {
        to: '/admin/email-logs',
        labelKey: 'Email logs',
        group: 'Other',
        icon: icon(
            <>
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="m3 7 9 6 9-6" />
            </>,
        ),
    },
    {
        to: '/admin/newsletter',
        labelKey: 'Newsletter',
        group: 'Other',
        icon: icon(
            <>
                <path d="M4 6h16v12H4z" />
                <path d="m4 7 8 6 8-6" />
            </>,
        ),
    },
    {
        to: '/admin/math-tests',
        labelKey: 'Math tests',
        group: 'Other',
        icon: icon(
            <>
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M8 9h8M8 15h3M15 15h1" />
            </>,
        ),
    },
    {
        to: '/admin/open-events-calendar',
        labelKey: 'Open events calendar',
        group: 'Other',
        icon: icon(
            <>
                <rect x="4" y="5" width="16" height="15" rx="2" />
                <path d="M8 3v4M16 3v4M4 11h16" />
                <path d="M8 15h2M14 15h2" />
            </>,
        ),
    },
    {
        to: '/admin/buzzers-results',
        labelKey: 'Buzzers results',
        group: 'Other',
        icon: icon(
            <>
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="3" />
                <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
            </>,
        ),
    },
    {
        to: '/admin/test',
        labelKey: 'Components test',
        group: 'Other',
        icon: icon(
            <>
                <path d="M9 3h6v6l5 9a2 2 0 0 1-1.7 3H5.7A2 2 0 0 1 4 18l5-9z" />
                <path d="M8 15h8" />
            </>,
        ),
    },
]

/** Home exit pinned at the bottom of the admin sidebar. */
export const ADMIN_FOOTER_LINKS = [
    {
        to: '/',
        end: true,
        labelKey: 'Home',
        icon: icon(
            <>
                <path d="M3 11.5 12 4l9 7.5" />
                <path d="M6 10.5V20h12v-9.5" />
            </>,
        ),
    },
]
